module.exports = __webpack_public_path__ + "img/cellVolt.59ca4c01.svg";